import React from 'react';
import {
    Typography, createStyles,
    Toolbar,
    Theme, WithStyles, withStyles, AppBar
} from "@material-ui/core";

const styles = (theme: Theme) => createStyles({
    root: {
        height: 56,
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
});

interface Props extends WithStyles<typeof styles> {
};

class InnerHeader extends React.Component<Props, {}> {
    render() {
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <AppBar position="fixed">
                    <Toolbar>
                        <Typography variant="h6" className={classes.title}>
                            Infinity Cats
                </Typography>
                    </Toolbar>
                </AppBar>
            </div>
        );
    }
}

export const Header = withStyles(styles)(InnerHeader);